import { render, staticRenderFns } from "./client-enrolments-tab.vue?vue&type=template&id=5f8a3ba7&scoped=true"
import script from "./client-enrolments-tab.vue?vue&type=script&lang=js"
export * from "./client-enrolments-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a3ba7",
  null
  
)

export default component.exports